export const title = 'Downloads cumulativos (gráfico)';

Total de instalações do app ao longo do tempo no intervalo selecionado.
